/* eslint-disable test-selectors/onChange */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
import { useEffect, useState } from 'react';

import classnames from 'classnames';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import { useLocation } from 'react-router';

import { getSubAccountWalletBalance, transferFundsSubAccount } from 'actions/user';
import Modal from 'components/modal';
import {
  RenderForGlobalExchange,
  RenderForIndianExchange,
} from 'components/render/RenderByExchangeType';
import { CoinDropDownModal } from 'components/withdrawal/withdrawal_styles';
import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { LOCALES } from 'constants/dateTime';
import { CURRENCY_TYPE } from 'constants/enums';
import routes from 'constants/routes';
import { parseSubAccountError } from 'errorMessages/user';
import { formatFiat } from 'helpers/currency';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { device } from 'helpers/screenSizes';
import {
  addZeroesUntilCorrectPrecision,
  convertFromINRtoUSD,
  convertFromUSDtoINR,
  cropAfterDecimals,
  getUserAccountNameById,
} from 'helpers/utils';
import useLockedBody from 'hooks/useLockedBody';
import { inrConversionRateSelector } from 'selectors/otherSelectors';
import { withDrawalEnabledWalletsSelectors } from 'selectors/walletSelector';
import { useAppDispatch } from 'storeHooks';
import {
  ArrowDownThin,
  ArrowUpThinActive,
  CancelIcon,
  MobileModalCloseIconNew,
  TransferIcon,
} from 'styles/assets/icons';
import IUser, { IUserKernel } from 'types/IUser';
import Button from 'UIKit/Button';
import KycConfirmButton from 'UIKit/KycConfirmButton';

import AmountInput from './amountInput';
import {
  AccountOptions,
  initError,
  initState,
  ITransferFundModalError,
  ITransferFundModalState,
  WithdrawalOptionList,
} from './helpers';
import { ModalWrapper } from './styles';
import styles from './trasnferFundModal.module.scss';

const MAIN_ACCOUNT = 'Main Account';
interface TransferFundModalProps {
  isModalOpen: boolean;
  handleCloseModal: () => void;
  subAccounts: IUserKernel[];
  user: IUser;
}

const TransferFundModal = ({
  isModalOpen,
  handleCloseModal,
  subAccounts,
  user,
}: TransferFundModalProps) => {
  useLockedBody(isModalOpen);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const withdrawalEnabledWallets = useSelector(withDrawalEnabledWalletsSelectors);

  const [state, setState] = useState<ITransferFundModalState>(initState);

  const [error, setError] = useState<ITransferFundModalError>(initError);
  const [isPending, setIsPending] = useState(false);

  const location = useLocation();

  const {
    sourceAccount,
    destinationAccount,
    selectedCoin,
    openSourceAccountOptions,
    openDestinationAccountOptions,
    openCoinList,
    sourceAccountBalanceObj,
    amount,
  } = state;

  const mainAccount = {
    account_name: MAIN_ACCOUNT,
    id: user.main_account ? user.main_account.id : user.id,
  };
  const subAccount = {
    account_name: user?.is_sub_account ? user?.account_name : null,
    id: user.is_sub_account ? user.id : null,
  };
  const accountInUse = getUserAccountNameById(user.id, user);

  const updateState = newObj => {
    setState(prev => ({
      ...prev,
      ...newObj,
    }));
  };

  const updateSourceAccountBalance = (accountToCheck = sourceAccount) => {
    if (accountToCheck?.id && selectedCoin) {
      const obj: {
        asset_symbol: string;
        sub_account_user_id?: string | number;
      } = {
        asset_symbol: selectedCoin,
      };

      if (accountToCheck?.id !== (user?.main_account?.id || user.id)) {
        obj.sub_account_user_id = accountToCheck.id;
      }

      // @ts-ignore
      dispatch(getSubAccountWalletBalance(obj))
        .then(data => {
          updateState({
            sourceAccountBalanceObj: {
              asset_symbol: selectedCoin,
              available_balance: Number(
                data.result.max_withdrawal_without_forfeiting || '0.00'
              ),
              precision: 2,
            },
          });
        })
        .catch(() => {
          updateState({
            sourceAccountBalanceObj: {
              asset_symbol: selectedCoin,
              available_balance: 0.0,
              precision: 2,
            },
          });
        });
    } else {
      updateState({
        sourceAccountBalanceObj: null,
      });
    }
  };
  const switchAccount = () => {
    // Use the functional form of setState to access the previous state
    setState(prev => {
      const newSourceAccount = prev.destinationAccount;
      const newDestinationAccount = prev.sourceAccount;
      if (IS_INDIAN_EXCHANGE) {
        // Call the function to update the balance for the new source account
        updateSourceAccountBalance(newSourceAccount);
      }

      return {
        ...prev,
        sourceAccount: newSourceAccount,
        destinationAccount: newDestinationAccount,
        selectedCoin: IS_INDIAN_EXCHANGE ? CURRENCY_TYPE.USD : null,
      };
    });
  };
  const setDefaultAccounts = () => {
    if (IS_INDIAN_EXCHANGE && location.pathname === routes.account.deposit) {
      // Add Funds page
      setState(prev => ({
        ...prev,
        sourceAccount: mainAccount,
        destinationAccount: subAccount,
        selectedCoin: CURRENCY_TYPE.USD,
      }));
    } else if (IS_INDIAN_EXCHANGE && location.pathname === routes.account.withdrawal) {
      // Withdraw Funds page
      setState(prev => ({
        ...prev,
        sourceAccount: subAccount,
        destinationAccount: mainAccount,
        selectedCoin: CURRENCY_TYPE.USD,
      }));
    } else {
      // Default case
      setState(prev => ({
        ...prev,
        sourceAccount: mainAccount,
        destinationAccount: '',
        selectedCoin: IS_INDIAN_EXCHANGE ? CURRENCY_TYPE.USD : prev.selectedCoin,
      }));
    }
  };

  const closeModal = () => {
    if (IS_INDIAN_EXCHANGE) {
      setDefaultAccounts();
    } else {
      setState({
        ...initState,
        sourceAccount: mainAccount,
      });
    }
    setError(initError);
    handleCloseModal();
  };
  // In the Indian Exchange, we take the amount input in INR.
  // However, to send the value in the API, we need to convert it back to USD since the API only accepts values in USD.
  const inrConversionRate = useSelector(inrConversionRateSelector);
  const usdAmount = convertFromINRtoUSD(parseFloat(amount), inrConversionRate);
  const amountToTransfer = IS_INDIAN_EXCHANGE ? usdAmount : amount;

  const submit = () => {
    const errorMsgs: ITransferFundModalError = {};
    if (!sourceAccount) {
      errorMsgs.sourceAccountError = t('errors:user.source_account');
    }
    if (!destinationAccount) {
      errorMsgs.destinationAccountError = t('errors:user.destination_account');
    }
    if (!selectedCoin) {
      errorMsgs.selectedCoinError = t('errors:user.coin');
    }

    if (!amountToTransfer || Number(amountToTransfer) <= 0) {
      errorMsgs.amountError = t('errors:custom.amount_empty');
    } else if (
      Number(amountToTransfer) > sourceAccountBalanceObj?.available_balance ||
      !sourceAccountBalanceObj?.available_balance ||
      sourceAccountBalanceObj?.available_balance === 0
    ) {
      errorMsgs.amountError = t('errors:user.insufficient_balance');
    }
    if (Object.keys(errorMsgs).length > 0) {
      setError(errorMsgs);
      return;
    }

    const data = {
      transferrer_user_id: sourceAccount?.id,
      transferee_user_id: destinationAccount?.id,
      asset_symbol: selectedCoin,
      amount: Number(amountToTransfer),
      transferrer_user: sourceAccount?.account_name,
      transferee_user: destinationAccount?.account_name,
    };
    setIsPending(true);

    // @ts-ignore
    dispatch(transferFundsSubAccount(data))
      .then(data => {
        setIsPending(false);
        closeModal();
      })
      .catch(err => {
        setIsPending(false);
        setError({
          ...error,
          responseError: parseSubAccountError(err),
        });
      });

    trackMixpanelEvent('Transfer Complete - Subaccounts', {
      account_in_use: accountInUse,
      source_account: data.transferrer_user,
      final_account: data.transferee_user,
    });
  };

  useEffect(() => {
    if (destinationAccount?.account_name === MAIN_ACCOUNT) {
      setState(prev => ({
        ...prev,
        selectedCoin: IS_INDIAN_EXCHANGE ? CURRENCY_TYPE.USD : null,
      }));
    }
  }, [destinationAccount]);

  useEffect(() => {
    if (state) {
      setError({ ...error, responseError: null });
    }
    if (amount) {
      setError({ ...error, amountError: null });
    }
  }, [state]);

  useEffect(() => {
    setDefaultAccounts();
    if (IS_INDIAN_EXCHANGE) {
      updateState({ selectedCoin: CURRENCY_TYPE.USD });
    }
  }, []);

  useEffect(() => {
    updateSourceAccountBalance(sourceAccount); // Call the function to update balance when sourceAccount or selectedCoin changes
  }, [sourceAccount, selectedCoin]);

  const onChangeCoin = ({ value }) => {
    updateState({
      selectedCoin: value,
      openCoinList: false,
      amount: '',
    });
    setError(prev => ({ ...prev, selectedCoinError: null, amountError: null }));
  };

  const onChangeSourceAccount = e => {
    updateState({
      sourceAccount: {
        id: e.label.props['data-symbol'],
        account_name: e.value,
      },
      openSourceAccountOptions: false,
    });
    setError({ ...error, sourceAccountError: null });
  };

  // only for global exchange currently
  const handleMaxAmountClick = () => {
    if (sourceAccountBalanceObj) {
      updateState({
        amount: (sourceAccountBalanceObj.available_balance || 0).toString(),
      });
    } else {
      updateState({
        amount: '0.00',
      });
    }
  };

  const onChangeDestinationAccount = e => {
    updateState({
      destinationAccount: {
        id: e.label.props['data-symbol'],
        account_name: e.value,
      },
      openDestinationAccountOptions: false,
    });
    setError({ ...error, destinationAccountError: null });
  };

  const usdValue = sourceAccountBalanceObj?.available_balance || 0;
  const formattedUsdValue = formatFiat(
    CURRENCY_TYPE.USD,
    cropAfterDecimals(
      addZeroesUntilCorrectPrecision(usdValue, sourceAccountBalanceObj?.precision),
      sourceAccountBalanceObj?.precision
    )
  );
  const formattedInrValue = formatFiat(
    CURRENCY_TYPE.INR,
    cropAfterDecimals(
      addZeroesUntilCorrectPrecision(
        convertFromUSDtoINR(Number(usdValue), inrConversionRate),
        sourceAccountBalanceObj?.precision
      ),
      sourceAccountBalanceObj?.precision
    ),
    LOCALES.INDIA
  );

  return (
    (<Modal
      className={classnames({
        'full-common-modal': !!isMobile,
        'common-modal-content': !isMobile,
      })}
      classOverlayName={classnames({
        'common-modal-overlay': !!isMobile,
      })}
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel={t('account:subAccount.transferFund')}
    >
      <div className={styles[`transfer-fund-modal`]}>
        <ModalWrapper>
          <div className={styles.heading}>
            <div className={styles.headingText}>
              {t('account:subAccount.transferFund')}
            </div>
            <div
              data-testid="close-subaccount-modal"
              aria-hidden="true"
              onClick={closeModal}
              className={styles['close-icon']}
            >
              <MobileModalCloseIconNew />
            </div>
          </div>
          <div className={styles.body}>
            <div className={styles.content}>
              <div className={styles.form}>
                <div className={styles['switch-user-content']}>
                  <div className={styles['draw-content']}>
                    <span className={styles.dot} />
                    <div className={styles.line} />
                    <div
                      data-testid="switch-icon"
                      aria-hidden="true"
                      className={styles[`switch-icon`]}
                      onClick={switchAccount}
                    >
                      <TransferIcon
                        arrowColor="var(--brand-bg-primary)"
                        circleColor="var(--brand-bg-primary)"
                        className={styles.transferIcon}
                        height={16}
                        width={16}
                      />
                    </div>

                    <div className={styles.line} />
                    <span className={styles.dot} />
                  </div>

                  <div className={styles['info-content']}>
                    <div className={styles.field}>
                      <div className={styles.label}>
                        {t('account:subAccount.transferFundModal.sourceAccount')}
                      </div>

                      <MediaQuery query={device.up.md}>
                        <div
                          className={classnames({
                            [`${styles.errorBorder}`]: error?.sourceAccountError,
                          })}
                        >
                          <AccountOptions
                            subAccounts={subAccounts}
                            // @ts-ignore
                            onChange={onChangeSourceAccount}
                            value={sourceAccount?.account_name}
                            selectedAccount={destinationAccount}
                            user={user}
                            keySlug="source"
                            mainAccount={mainAccount}
                          />
                        </div>

                        {error.sourceAccountError && (
                          <div className={styles.error} data-palette="TransferFundModal">{error?.sourceAccountError}</div>
                        )}
                      </MediaQuery>
                      <MediaQuery query={device.down.md}>
                        <div
                          data-testid="account-dropdown-label"
                          aria-hidden="true"
                          className={classnames(styles['dropdown-label'], {
                            [`${styles.errorBorder}`]: error?.sourceAccountError,
                          })}
                          onClick={() => {
                            updateState({
                              openSourceAccountOptions: !openSourceAccountOptions,
                            });
                          }}
                        >
                          <span className={styles.option}>
                            {sourceAccount?.account_name || ''}
                          </span>
                          {openSourceAccountOptions ? (
                            <ArrowUpThinActive />
                          ) : (
                            <ArrowDownThin />
                          )}
                        </div>
                        {error.sourceAccountError && (
                          <div className={styles.error} data-palette="TransferFundModal">{error.sourceAccountError}</div>
                        )}
                        <CoinDropDownModal isOpen={openSourceAccountOptions}>
                          <div className="modal-header">
                            {t('account:subAccount.transferFundModal.sourceAccount')}
                            <span
                              data-testid="account-coin-dropdown"
                              aria-hidden="true"
                              className="close-icon"
                              onClick={() =>
                                updateState({
                                  openSourceAccountOptions: !openSourceAccountOptions,
                                })
                              }
                            >
                              <CancelIcon />
                            </span>
                          </div>
                          <AccountOptions
                            subAccounts={subAccounts}
                            // @ts-ignore
                            onChange={onChangeSourceAccount}
                            value={sourceAccount?.account_name}
                            selectedAccount={destinationAccount}
                            user={user}
                            keySlug="source"
                            mainAccount={mainAccount}
                          />
                        </CoinDropDownModal>
                      </MediaQuery>
                    </div>

                    <div className={styles.field}>
                      <div className={styles.label}>
                        {t('account:subAccount.transferFundModal.destinationAccount')}
                      </div>
                      <MediaQuery query={device.up.md}>
                        <div
                          className={classnames({
                            [`${styles.errorBorder}`]: error?.destinationAccountError,
                          })}
                        >
                          <AccountOptions
                            subAccounts={subAccounts}
                            // @ts-ignore
                            onChange={onChangeDestinationAccount}
                            value={destinationAccount?.account_name}
                            selectedAccount={sourceAccount}
                            keySlug="destination"
                            user={user}
                            mainAccount={mainAccount}
                          />
                        </div>
                        {error?.destinationAccountError && (
                          <div className={styles.error} data-palette="TransferFundModal">
                            {error?.destinationAccountError}
                          </div>
                        )}
                      </MediaQuery>
                      <MediaQuery query={device.down.md}>
                        <div
                          data-testid="account-dropdown-label"
                          aria-hidden="true"
                          className={classnames(styles['dropdown-label'], {
                            [`${styles.errorBorder}`]: error?.destinationAccountError,
                          })}
                          onClick={
                            () =>
                              updateState({
                                openDestinationAccountOptions:
                                  !openDestinationAccountOptions,
                              })
                            // setOpenDestinationAccountOptions(prev => !prev)
                          }
                        >
                          <span className={styles.option}>
                            {destinationAccount?.account_name || ''}
                          </span>
                          {openDestinationAccountOptions ? (
                            <ArrowUpThinActive />
                          ) : (
                            <ArrowDownThin />
                          )}
                        </div>
                        {error?.destinationAccountError && (
                          <div className={styles.error} data-palette="TransferFundModal">
                            {error?.destinationAccountError}
                          </div>
                        )}
                        <CoinDropDownModal isOpen={openDestinationAccountOptions}>
                          <div className="modal-header">
                            {t('account:subAccount.transferFundModal.destinationAccount')}
                            <span
                              data-testid="account-coin-dropdown"
                              aria-hidden="true"
                              className="close-icon"
                              onClick={() =>
                                updateState({
                                  openDestinationAccountOptions:
                                    !openDestinationAccountOptions,
                                })
                              }
                            >
                              <CancelIcon />
                            </span>
                          </div>
                          <AccountOptions
                            subAccounts={subAccounts}
                            // @ts-ignore
                            onChange={onChangeDestinationAccount}
                            value={destinationAccount?.account_name}
                            selectedAccount={sourceAccount}
                            keySlug="destination"
                            user={user}
                            mainAccount={mainAccount}
                          />
                        </CoinDropDownModal>
                      </MediaQuery>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.divider} />
              <div className={styles.form}>
                <RenderForGlobalExchange>
                  <div className={styles.coinField}>
                    <div className={styles.label}>
                      {t('account:subAccount.transferFundModal.coin')}
                    </div>
                    <MediaQuery query={device.up.md}>
                      <>
                        <div
                          data-testid="account-select-coin-button"
                          aria-hidden="true"
                          className={classnames(styles['select-coin-button'], {
                            [`${styles.errorBorder}`]: error?.selectedCoinError,
                          })}
                          onClick={() => {
                            updateState({ openCoinList: !openCoinList });
                            // setOpenCoinList(prev => !prev);
                          }}
                          data-palette="TransferFundModal">
                          <span>{selectedCoin || ''}</span>
                          <div>
                            {openCoinList ? <ArrowUpThinActive /> : <ArrowDownThin />}
                          </div>
                        </div>
                        {error.selectedCoinError && (
                          <div className={styles.error} data-palette="TransferFundModal">{error.selectedCoinError}</div>
                        )}
                        <div className={styles['coin-list-panel']} data-palette="TransferFundModal">
                          <div
                            className={classnames(styles['coin-panel'], {
                              'd-none': !openCoinList,
                            })}
                          >
                            <WithdrawalOptionList
                              // @ts-ignore
                              enabledWallets={withdrawalEnabledWallets}
                              onChange={onChangeCoin}
                              value={selectedCoin}
                            />
                          </div>
                        </div>
                      </>
                    </MediaQuery>
                    <MediaQuery query={device.down.md}>
                      <div
                        data-testid="account-dropdown-label"
                        aria-hidden="true"
                        className={classnames(styles['dropdown-label'], {
                          [`${styles.errorBorder}`]: error?.selectedCoinError,
                        })}
                        onClick={() => updateState({ openCoinList: !openCoinList })}
                      >
                        <span className={styles.option}>{selectedCoin}</span>
                        {openCoinList ? <ArrowUpThinActive /> : <ArrowDownThin />}
                      </div>
                      {error.selectedCoinError && (
                        <div className={styles.error} data-palette="TransferFundModal">{error.selectedCoinError}</div>
                      )}
                      <CoinDropDownModal isOpen={openCoinList}>
                        <div className="modal-header">
                          {t('account:selectCoin')}
                          <span
                            data-testid="account-coin-dropdown"
                            aria-hidden="true"
                            className="close-icon"
                            onClick={() => updateState({ openCoinList: !openCoinList })}
                          >
                            <CancelIcon />
                          </span>
                        </div>
                        {withdrawalEnabledWallets && (
                          <WithdrawalOptionList
                            // @ts-ignore
                            enabledWallets={withdrawalEnabledWallets}
                            onChange={onChangeCoin}
                            value={selectedCoin}
                          />
                        )}
                      </CoinDropDownModal>
                    </MediaQuery>
                  </div>
                </RenderForGlobalExchange>
                <div className={styles.amountField}>
                  <div className={styles['row-label-content']}>
                    <div className={styles.amountLabel}>
                      {t('account:subAccount.transferFundModal.amount')}
                    </div>
                    {!!sourceAccountBalanceObj && (
                      <div data-palette="TransferFundModal">
                        <span
                          className={classnames(styles['avail-balance-label'], {
                            [styles['indian-avail-balance-label']]: IS_INDIAN_EXCHANGE,
                          })}
                        >
                          {t('account:subAccount.transferFundModal.availBalance')}
                        </span>

                        <span className={styles['avail-balanceValue']}>
                          <RenderForGlobalExchange>
                            {(sourceAccountBalanceObj?.available_balance || 0).toFixed(
                              sourceAccountBalanceObj?.precision
                            )}{' '}
                            {sourceAccountBalanceObj?.asset_symbol}
                          </RenderForGlobalExchange>
                          <RenderForIndianExchange>
                            <span className={styles.inrValue}> {formattedInrValue} </span>
                            <span className={styles.usdValue}>
                              {' '}
                              ({formattedUsdValue}){' '}
                            </span>
                          </RenderForIndianExchange>
                        </span>
                      </div>
                    )}
                  </div>
                  <AmountInput
                    selectedCoin={selectedCoin}
                    updateState={updateState}
                    amount={amount}
                    handleMaxAmountClick={handleMaxAmountClick}
                    errorMessage={error?.amountError}
                  />
                  {error?.amountError && (
                    <div className={styles.error} data-palette="TransferFundModal">{error?.amountError}</div>
                  )}
                </div>
              </div>
            </div>

            <div className={styles.footer}>
              {error?.responseError && (
                <div className={styles.error} data-palette="TransferFundModal">{error?.responseError}</div>
              )}
              <MediaQuery query={device.up.md}>
                <div className={styles[`buttons-container`]}>
                  <KycConfirmButton
                    data-testid="account-transfer-button"
                    disabled={isPending}
                    className={styles[`modal-button`]}
                    onClick={submit}
                  >
                    {t('account:subAccount.transferFundModal.transferNow')}
                  </KycConfirmButton>
                  {/* <KycCancelButton
                    className={styles[`modal-button`]}
                    onClick={closeModal}>
                    {t('account:subAccount.cancel')}
                  </KycCancelButton> */}
                </div>
              </MediaQuery>
              <MediaQuery query={device.down.md}>
                <Button
                  data-testid="account-transfer-button"
                  disabled={isPending}
                  className={styles[`confirm-button-mobile`]}
                  onClick={submit}
                >
                  {t('account:subAccount.transferFundModal.transferNow')}
                </Button>
              </MediaQuery>
            </div>
          </div>
        </ModalWrapper>
      </div>
    </Modal>)
  );
};
export default TransferFundModal;
